import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { DrilldownFormsService } from '../../services/drilldown-forms.service';
import { CasualReportService } from '../../services/casual-report.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'action-option-button',
  template: `
    <span fxFlex>
      <button
        type="button"
        mat-button
        fxFlex
        class="bold grid-text"
        style="text-decoration: underline"
        vrm-color
        (click)="triggerLinkButtonAction()"
        *ngIf="value"
      >
        {{ this.cService.readyTranslations.reportData[value] }}
      </button>
    </span>
  `,
  styles: [],
})
export class ActionOptionButtonCasualReportComponent implements ICellRendererAngularComp {
  public value: string;

  constructor(
    private dfService: DrilldownFormsService,
    private crService: CasualReportService,
    public cService: CommonService
  ) {}

  agInit(params: ICellRendererParams) {
    this.value = params.value;
  }

  triggerLinkButtonAction(triggeredButton?: string) {
    setTimeout(() => {
      if (triggeredButton === 'options-print') {
        console.log('%c PRINT', 'color: salmon');
      } else if (triggeredButton === 'options-email') {
        console.log('%c SEND AS EMAIL', 'color: salmon');
      } else if (triggeredButton === 'options-delete') {
        console.log('%c DELETE SELECTED', 'color: salmon');
      } else {
        // Assume main action was triggered
        if (this.crService.selectedRows.length === 1) {
          this.dfService.launchSelectedIntervention(this.crService.selectedRows[0]);
        }
      }
    }, 100); // <-- Wait for selectedRow to be up-to-date
  }

  refresh(): boolean {
    return false;
  }
}
